import React, { createContext, useEffect, useState } from 'react';

const TOKEN = process.env.REACT_APP_TOKEN;
export const TokenContext = createContext('');

// This is a temporary solution to tackle the cZar token being fetchable from a URL.
// In the future, we'll need to integrate this directly into SSO as well.

const CzarTokenFetcher = async () => {
  const params = new URLSearchParams(window.location.search);
  const env = params.get('env');
  const subDomain = env ? `${env}-czar` : 'czar'
  const jwtUrl = `https://${subDomain}.cyllenius.com/czar/jwt`;
  if (jwtUrl) {
    try {
      const resp = await fetch(jwtUrl, { credentials: 'include' });
      return resp.status === 200 ? await resp.text() : '';
    } catch (e) {
      console.log(e);
    }
  }
}

const TokenFetchers = {
  'CZAR': CzarTokenFetcher
};

export const TokenProvider = ({ children }) => {
  const params = new URLSearchParams(window.location.search);
  const app = params.get('app');
  const [token, setToken] = useState<string>(TOKEN || '');

  useEffect(() => {
    if (!token && app && TokenFetchers[app]) {
      TokenFetchers[app]().then((token) => setToken(token));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <TokenContext.Provider value={token}>
      {children}
    </TokenContext.Provider>
  );
};
